var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-app',{attrs:{"id":"app"}},[_c('ion-content',[_c('Menu'),_c('router-view'),_c('br'),_c('br')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }